import React from "react";
import PropTypes from 'prop-types';
import { myDate } from '../../../../Function/dateTime';
import dompurify from 'dompurify';
import Slider from './slider'



const content = (props) => {
    const { Title, namFamil, DateSabt, Content, idNews } = props;
    const sanitizer = dompurify.sanitize;

    return (

        <div className="post">
            {/* <div className="media">
                <img src={process.env.PUBLIC_URL + "/assets/images/news-details/img-1.jpg"} alt='' role='presentation' className="img img-responsive" />
            </div> */}
            <br />
            <div className="post-title-meta">

                <h2>{Title}</h2>
                <ul>
                    <li>{namFamil}</li>
                    <li>{myDate(DateSabt)}</li>
                </ul>
            </div>
            <div className="post-body"  >

                <p dangerouslySetInnerHTML={{ __html: sanitizer(Content) }} />
                <br />

                <Slider idNews={idNews} />


            </div>



        </div>



    );
};


content.propTypes = {

    DateSabt: PropTypes.string.isRequired,
    idNews: PropTypes.string.isRequired,
};


// let styles = {
//     margin: 'auto',
//     width: '500px'
// };

export default content; 